import { Component, Input, OnInit } from '@angular/core';
import { BasePanelMenuItem } from 'primeng/panelmenu';

@Component({
  selector: 'app-estadocuentamasivo-captura',
  templateUrl: './estadocuentamasivo-captura.component.html',
  styleUrls: ['./estadocuentamasivo-captura.component.css']
})
export class EstadocuentamasivoCapturaComponent implements OnInit {

  @Input() tituloInput: string;
  fechafac: Date;
  fechavence: Date;
  avisoDirectivo: boolean;
  constructor() { }

  ngOnInit(): void {
  }

}
